import AUStates from './en-US/AU-states.json.js';
import CAStates from './en-US/CA-states.json.js';
import CNStates from './en-US/CN-states.json.js';
import CompanySize from './en-US/company-size.json.js';
import CompanyType from './en-US/company-type.json.js';
import countries from './en-US/countries.json.js';
import DEStates from './en-US/DE-states.json.js';
import HKStates from './en-US/HK-states.json.js';
import INStates from './en-US/IN-states.json.js';
import industry from './en-US/industry.json.js';
import interests from './en-US/interests.json.js';
import jobRole from './en-US/job-role.json.js';
import levelOfAWSUsage from './en-US/level-of-aws-usage.json.js';
import projectTimeline from './en-US/project-timeline.json.js';
import PTStates from './en-US/PT-states.json.js';
import USStates from './en-US/US-states.json.js';
import useCase from './en-US/use-case.json.js';
import languagePreference from './en-US/language-preference.json.js';
import Navatar from '../en-US/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
